import React, { lazy, useEffect, useState } from 'react'
import { Route, Switch } from 'react-router-dom'
import GlobalHeader from 'components/GlobalHeader'
import GlobalFooter from 'components/GlobalFooter'
import Menu from 'components/Menu'
import SuspenseWithChunkError from 'components/SuspenseWithChunkError'
import PageLoader from 'components/Loader/PageLoader'
import { API_ADDRESS } from 'config'

// import { useAppDispatch } from 'state'
// import { Event } from 'react-socket-io'
// import { receiveEvent } from 'state/events/index'

// Route-based code splitting
const Home = lazy(() => import('./Home'))
// const Scraping = lazy(() => import('./Scraping/Scraping'))
// const Councils = lazy(() => import('./Councils/Councils'))
// const Buildings = lazy(() => import('./Buildings/Buildings'))
// const ScrapeHistory = lazy(() => import('./ScrapeHistory/ScrapeHistory'))
// const Crons = lazy(() => import('./Crons/Crons'))
// const NotFound = lazy(() => import('./NotFound'))
// const ProfileScreen = lazy(() => import('./Users/ProfileScreen'))
// const RegisterScreen = lazy(() => import('./Users/RegisterScreen'))
// const ListUsersScreen = lazy(() => import('./Users/ListUsersScreen'))
// const UpdateUserScreen = lazy(() => import('./Users/UpdateUserScreen'))
// const AssignListings = lazy(() => import('./AssignListings/AssignListings'))
// const AssignedListings = lazy(() => import('./AssignedListings/AssignedListings'))
// const CouncilsManage = lazy(() => import('./CouncilsManage/CouncilsManage'))
// const TeamWork = lazy(() => import('./TeamWork/TeamWork'))
// const QaWork = lazy(() => import('./QaWork/QaWork'))

  const tokenData = localStorage.getItem('bba-token') ? JSON.parse(localStorage.getItem('bba-token')) : null
  // console.log("tokenData",tokenData)

	const getUserDetails = async () => {
		try{

      const config = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${tokenData.token}`,
        },
      }

      const response = await fetch(`${API_ADDRESS}/users/assigned-stats`, config)
			const data = await response.json()

			if(data?.message?.includes('token')){
				localStorage.clear()
				sessionStorage.clear()
				window.location.href='/login'
			}else{
				return data.find( user => user._id === tokenData._id )
      }
		} catch(error) {
			// ... console.log(error)
		}
    return []
	}

const Dashboard = () => {

  /*
  const dispatch = useAppDispatch()

  const onEvent = (event) => {
    dispatch(receiveEvent(event))
  }
  */

  const [user, setUser] = useState(tokenData)

  useEffect(() => {
    getUserDetails().then( data => {
       setUser(data)
    })
  },[])

/*
      <Event event="event" handler={onEvent} />
*/
/*
              <Route path="/profile"            component={user?.role === 'Admin' ? lazy(() => import('./Users/ProfileScreen')) : null} />
              <Route path="/register"           component={user?.role === 'Admin' ? lazy(() => import('./Users/RegisterScreen')) : null} />
              <Route path="/user-profile"       component={user?.role === 'Admin' ? lazy(() => import('./Users/UpdateUserScreen')) : null} />
              <Route path="/qa-work"            component={user?.role === 'Admin' ? lazy(() => import('./QaWork/QaWork')) : null} />
              <Route path="/team-work"          component={user?.role === 'Admin' ? lazy(() => import('./TeamWork/TeamWork')) : null} />
              <Route path="/crons"              component={user?.role === 'Admin' ? lazy(() => import('./Crons/Crons')) : null} />

              <Route path="/property/:id"><Property /></Route>
*/

  return (
    <>
      <GlobalHeader />
      <Menu>
        <SuspenseWithChunkError fallback={<PageLoader />}>
          <Switch>
              <Route path="/" exact><Home /></Route>
              <Route path="/councils"           component={user?.role === 'Admin' ? lazy(() => import('./Councils/Councils')) : null} />
              <Route path="/scrapes"            component={user?.role === 'Admin' ? lazy(() => import('./Councils/Councils')) : null} />
              <Route path="/bookings"           component={user?.role === 'Admin' ? lazy(() => import('./Councils/Councils')) : null} />
              <Route path="/listings"           component={user?.role === 'Admin' ? lazy(() => import('./Councils/Councils')) : null} />
              <Route path="/listings-websites"  component={user?.role === 'Admin' ? lazy(() => import('./Councils/Councils')) : null} />
              <Route path="/properties"         component={user?.role === 'Admin' ? lazy(() => import('./Councils/Councils')) : null} />
              <Route path="/broken-listings"    component={user?.role === 'Admin' ? lazy(() => import('./Councils/Councils')) : null} />
              <Route path="/broken-properties"  component={user?.role === 'Admin' ? lazy(() => import('./Councils/Councils')) : null} />
              <Route path="/property"           component={user?.role === 'Admin' ? lazy(() => import('./Property')) : null} />
              <Route path="/buildings"          component={user?.role === 'Admin' ? lazy(() => import('./Buildings/Buildings')) : null} />
              <Route path="/assign-listings"    component={user?.role === 'Admin' ? lazy(() => import('./AssignListings/AssignListings')) : null} />
              <Route path="/assigned-listings"  component={user?.role === 'Admin' || user?.role === 'Editor' ?  lazy(() => import('./AssignedListings/AssignedListings')) : null} />
              <Route path="/qa-listings"        component={user?.role === 'Admin' ?  lazy(() => import('./QAListings/QAListings')) : null} />
              <Route path="/councils-manage"    component={user?.role === 'Admin' ? lazy(() => import('./CouncilsManage/CouncilsManage')) : null} />
              <Route path="/list-users"         component={user?.role === 'Admin' && user?.isAdmin === true ? lazy(() => import('./Users/ListUsersScreen')) : null} />
              <Route path="/login-attempts"     component={user?.role === 'Admin' && user?.isAdmin === true ? lazy(() => import('./LoginAttempts/LoginAttempts')) : null} />
              <Route path="/scraping"           component={user?.role === 'Admin' ? lazy(() => import('./Scraping/Scraping')) : null} />
              <Route path="/history"            component={user?.role === 'Admin' ? lazy(() => import('./ScrapeHistory/ScrapeHistory')) : null} />
            {/* 404 */}
            <Route component={lazy(() => import('./NotFound'))} />
          </Switch>
        </SuspenseWithChunkError>
      </Menu>
      <GlobalFooter />
    </>
  )
}

export default React.memo(Dashboard)
